import { createStore } from 'vuex'

export default createStore({
  state: {
	  BASEURL:process.env.VUE_APP_BASE_URL,//请求地址
	  BASEFILEURL:'http://qiniu.51ncdg.com/',//查看七牛图片地址
	  QINIUUPLOADURL:'https://up-z2.qiniup.com',//七牛上传地址
	  localeLang:localStorage.getItem('lang') || 'zh'
  },
  getters: {
  },
  mutations: {
	  SET_LANG(state, data) {
	  	state.localeLang = data
	  	localStorage.setItem('lang', data)
	  }
  },
  actions: {
  },
  modules: {
  }
})
